import React from 'react';
import ThemeProvider from '@proofpoint/fuse/components/ThemeProvider';
import fuseFontLoader from '@proofpoint/fuse/utils/fontLoader';
import muiLicenseInit from '@proofpoint/fuse/utils/muiLicense';
import { Auth0Provider } from '@auth0/auth0-react';
import { RequestProvider } from './context/RequestProvider';
import { ResultsProvider, initResultsState, resultsReducer } from './context/ResultsProvider';
import { CartridgesProvider, cartridgesReducer, initCartridgesState } from './context/CartridgesProvider';
import { CartridgeVersionProvider, initSelectedCartridgeState } from './context/CartridgeVersionProvider';
import { SupportProvider, supportReducer, initSupportState } from './context/SupportProvider';
import { AssertionProvider, assertReducer, initAssertState } from './context/AssertionProvider';
import { createRoot } from 'react-dom/client';
import App from './App';

const container = document.getElementById('root');
const root = createRoot(container);

fuseFontLoader();
muiLicenseInit();

root.render(
  <React.StrictMode>
      <Auth0Provider
        domain={process.env.REACT_APP_AUTH0_DOMAIN}
        clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
        //scope={process.env.REACT_APP_AUTH0_SCOPE}
        authorizationParams={{
          redirect_uri: window.location.origin,
          audience: process.env.REACT_APP_AUTH0_AUDIENCE,
          scope: "openid email profile " + process.env.REACT_APP_AUTH0_SCOPE,
        }}
      >
        <RequestProvider>  
          <CartridgesProvider initialState={initCartridgesState} reducer={cartridgesReducer}>
            <CartridgeVersionProvider initialState={initSelectedCartridgeState} reducer={resultsReducer}>
              <ResultsProvider initialState={initResultsState} reducer={resultsReducer}>
                <SupportProvider initialState={initSupportState} reducer={supportReducer}>
                  <AssertionProvider initialState={initAssertState} reducer={assertReducer}>
                    <ThemeProvider>
                      <App />
                    </ThemeProvider>                 
                  </AssertionProvider>
                </SupportProvider>
              </ResultsProvider>
            </CartridgeVersionProvider>
          </CartridgesProvider>
        </RequestProvider>  
      </Auth0Provider>
  </React.StrictMode>,
);
